module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-1-2-058ce3317b178059c722aaa21302d67d.jpg";